<template>
  <GoogleMap
    v-if="center"
    api-key="AIzaSyDkH0h-tiV4vG3VydfoHwi6sXqoxrmzRoA"
    style="width: 100%; height: 500px"
    :center="center"
    :zoom="12"
  >
    <Marker v-for="marker in markers" :key="marker.id" @click="onClick(marker)" :options="{ position: marker.coordinates }" />
  </GoogleMap>
</template>

<script>
import { GoogleMap, Marker } from 'vue3-google-map'
import { ref } from "vue";

export default {
  name: 'Map',
  components: { GoogleMap, Marker },
  props: {
    markers: {
      required: true,
      type: Array
    }
  },
  setup(props) {
    const center = ref(
      props.markers.length ? props.markers[0].coordinates : null
    )

    function onClick({ uri }) {
      window.location.href = uri
    }

    return { center, onClick }
  }
}
</script>
